import {Quill} from 'react-quill';
import ImageResize from 'quill-image-resize-module-react';

Quill.register('modules/imageResize', ImageResize);

// `matchVisual` (on by default) measures the rendered geometry of the HTML being
// loaded and inserts an extra newline wherever it believes it sees a visual gap.
// Since we load our own saved HTML back into the editor, leaving it on turns
// every `<p><br></p>` into several more of them on every edit.
export const CLIPBOARD_MODULE = {matchVisual: false};

export const EDITOR_MODULES = {
    clipboard: CLIPBOARD_MODULE,
    imageResize: {parchment: Quill.import('parchment')},
    toolbar: [
        [{ size: [] }],
        [{ align: [] }, 'direction' ],
        [ 'bold', 'italic', 'underline', 'strike' ],
        [{ color: [] }, { background: [] }],
        [{ script: 'super' }, { script: 'sub' }],
        ['blockquote', 'code-block' ],
        [{ list: 'ordered' }, { list: 'bullet'}, { indent: '-1' }, { indent: '+1' }],
        [ 'link', 'image', 'video' ],
        [ 'clean' ]        ],
}
